// src/modules/core/_main.module/_common.module/base-classes.module/_logger.part/utils/_parts/safe-stringify.util.ts

export function safeStringifyIsomorphic(
  value: unknown,
  replacer: (key: string, val: unknown) => unknown,
  depthLimit = 10,
  edgesLimit = 100,
): string {
  const seen = new Set<unknown>();
  const depthMap = new Map<unknown, number>();

  function internalReplacer(this: unknown, key: string, val: unknown): unknown {
    let processedValue = replacer.call(this, key, val);

    if (processedValue !== null && typeof processedValue === 'object') {
      if (seen.has(processedValue)) {
        return '[Circular]';
      }

      const parentDepth = depthMap.get(this) ?? 0;
      const currentDepth = parentDepth + 1;

      if (currentDepth > depthLimit) {
        return '[Object]';
      }

      seen.add(processedValue);
      depthMap.set(processedValue, currentDepth);

      if (!Array.isArray(processedValue)) {
        const keys = Object.keys(processedValue);
        if (keys.length > edgesLimit) {
          const truncatedObj: Record<string, unknown> = {};
          const visibleKeys = keys.slice(0, edgesLimit);

          for (const k of visibleKeys) {
            truncatedObj[k] = (processedValue as Record<string, unknown>)[k];
          }
          truncatedObj['... [TRUNCATED EDGES]'] =
            `And ${keys.length - edgesLimit} more fields`;
          processedValue = truncatedObj;
        }
      } else {
        if (processedValue.length > edgesLimit) {
          const truncatedArr = processedValue.slice(0, edgesLimit) as unknown[];
          truncatedArr.push(
            `... [TRUNCATED EDGES] And ${processedValue.length - edgesLimit} more items`,
          );
          processedValue = truncatedArr;
        }
      }
    }

    return processedValue;
  }

  try {
    return JSON.stringify(value, internalReplacer);
  } finally {
    seen.clear();
    depthMap.clear();
  }
}
